// The backend marks a user's OnlineJobs.ph integration "needs_reconnect" when OLJ
// rejects the saved email/password. Auto Apply pauses and OLJ apply endpoints answer
// 409 with this code until the user reconnects (integration/services/olj_connection.py).
export const OLJ_RECONNECT_CODE = "olj_reconnect_required";

// A connect attempt OnlineJobs.ph rejected (HTTP 401). Same wording as the
// backend's WRONG_LOGIN_MESSAGE (integration/services/olj_connection.py), so
// Settings and onboarding say the same thing.
export const OLJ_WRONG_LOGIN_MESSAGE =
  "Incorrect email or password. Please check your OnlineJobs.ph login and try again.";

// Opens Settings → Integrations with the OLJ reconnect form already open.
export const OLJ_RECONNECT_ROUTE = {
  path: "/settings",
  query: { section: "integrations", reconnect: "olj" },
};

export function isOljNeedsReconnect(status) {
  return status === "needs_reconnect";
}

// Accepts an axios error or a response/task payload.
export function isOljReconnectError(errorOrData) {
  const data = errorOrData?.response?.data ?? errorOrData;
  return data?.code === OLJ_RECONNECT_CODE;
}
